
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CustomerTenantModel extends Model<CustomerTenantModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'domainPrefix', type: 'string' },
		{ name: 'externalPublisherCustomerId', type: 'string' },
		{ name: 'contactMail', type: 'string' }
	];
	[key: string]: any;
	
	public id: number;
	public name: string;
	public domainPrefix: string;
	public externalPublisherCustomerId: string;
	public contactMail: string;
    
	constructor(){
		super();
		this.id = 0;
		this.name = '';
		this.domainPrefix = '';
		this.externalPublisherCustomerId = '';
		this.contactMail = '';
		
	}
	getProperties(){
		return CustomerTenantModel.classProperties;
	}
}

